import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import CalculatorPage from './components/CalculatorPage';
import AuthPage from './components/AuthPage';
import AdminPage from './components/AdminPage';
import AccessibilityStatement from './components/AccessibilityStatement';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import './firebase'
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="/accessibility" element={<AccessibilityStatement />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;